import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <nav className="float-left">
            <ul>
              <li>
                <a href="http://venturegarage.in/">Venture Garage</a>
              </li>
              <li>
                <a href="http://venturegarage.in/about-us/">About Us</a>
              </li>
              <li>
                <a href="http://venturegarage.in/contact/">Contact Us</a>
              </li>
              <li>
                <a href="http://venturegarage.in/privacy-policy/">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="http://venturegarage.in/disclaimer/">Disclaimer</a>
              </li>
              <li>
                <a href="http://venturegarage.in/terms-and-conditions/">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </nav>
          <div style={{ display: "none" }}>
            Developer:- Avinash Tiwari
            <a href="https://avinash-tiwari.github.io">Website link</a>
          </div>
        </div>
      </footer>
    );
  }
}
